import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/route/',
    name: 'Route',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['d7a-default-md-route:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "master" */ '@/router/views/route'),
  },

  {
    path: '/route/monitoring/',
    name: 'Route Monitoring',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['d7a-default-md-route:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/route/monitoring/'),
  },

  {
    path: '/route/planning/',
    name: 'Route Planning',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'd7a-default-md-route:read',
            'd7a-default-md-route:create',
            'd7a-default-md-route:update',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/route/planning/'),
  },

  {
    path: '/route/planning/form/:routeRecordId?',
    name: 'Route Planning Form',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['d7a-default-md-route:update'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/route/planning/form'),
  },

  {
    path: '/route/planning/update-history/:routeRecordId',
    name: 'Route Planning Update History',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['d7a-default-md-route:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "setting" */ '@/router/views/route/planning/listhistory'),
  },

  {
    path: '/route/monitoring/public-tracking',
    name: 'Route Tracking',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['d7a-default-md-route:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "setting" */ '@/router/views/route/public-tracking/'),
  },
]
